export const HEAREN_STATES = {
  DISCOVERY: {
    id: 'discovery',
    suggestionKey: 'discovery',
    heraAdviceKey: 'hera_breathe_and_listen',
  },

  EVENING_RETURN: {
    id: 'evening_return',
    suggestionKey: 'evening_return',
    heraAdviceKey: 'hera_evening_soft_listening',
  },

  FATIGUE_SOFTENING: {
    id: 'fatigue_softening',
    suggestionKey: 'fatigue_softening',
    heraAdviceKey: 'hera_no_need_to_force',
  },

  DEEP_IMMERSION: {
    id: 'deep_immersion',
    suggestionKey: null,
    heraAdviceKey: 'hera_familiar_sound',
  },

  PROFILE_READY: {
    id: 'profile_ready',
    suggestionKey: 'profile_ready',
    heraAdviceKey: 'hera_profile_ready',
  },

  READY_FOR_DEEPER: {
    id: 'ready_for_deeper',
    suggestionKey: 'ready_for_deeper',
    heraAdviceKey: 'hera_personalization_can_wait',
  },
};